import axios, { isCancel } from 'axios'
import { routesLogin as routes, bannerInfo } from '../routes'
import { sanitizeRedirectUrl } from '../utils/url-validation'
import { cookieNameAppAutoRedirect } from '../constants/app'
import {
    ACTIVATE_AUTHENTICATOR_CODE,
    ACTIVATE_AUTHENTICATOR_CODE_ERROR,
    ACTIVATE_AUTHENTICATOR_CODE_NEXT_STEP,
    ACTIVATE_AUTHENTICATOR_CODE_SUCCESS,
    FORGOTPWD,
    FORGOTPWD_SUCCESS,
    FORGOTPWD_ERROR,
    INIT_AUTHENTICATORS,
    INIT_AUTHENTICATORS_ERROR,
    INIT_AUTHENTICATORS_SUCCESS,
    INIT_ENROLL_AUTH_FACTOR,
    INIT_ENROLL_AUTH_FACTOR_ERROR,
    INIT_ENROLL_AUTH_FACTOR_SUCCESS,
    ON_AUTHENTICATE,
    ON_AUTHENTICATE_ERROR,
    ON_AUTHENTICATE_SUCCESS,
    ON_BACK_AUTHENTICATORS,
    ON_BACK_OPTIONAL_AUTHENTICATORS,
    ON_BACK_FALLBACK_ENFORCE_MFA,
    ON_BACK_FALLBACK_ENFORCE_MFA_TWO_STEPS,
    ON_ENROLL_MFA,
    ON_ENROLL_MFA_ERROR,
    ON_ENROLL_MFA_SUCCESS,
    ON_INIT,
    ON_INIT_SUCCESS,
    ON_INIT_ERROR,
    ON_LOGIN_APP,
    ON_LOGIN_APP_ERROR,
    ON_LOGIN_APP_SUCCESS,
    ON_RESEND_AUTH_CHALLENGE,
    ON_RESEND_AUTH_CHALLENGE_ERROR,
    ON_RESEND_AUTH_CHALLENGE_SUCCESS,
    ON_RESEND_CHALLENGE,
    ON_RESEND_CHALLENGE_ERROR,
    ON_RESEND_CHALLENGE_SUCCESS,
    ON_VERIFY_ACCOUNT_RECOVERY,
    ON_VERIFY_ACCOUNT_RECOVERY_ERROR,
    ON_VERIFY_ACCOUNT_RECOVERY_SUCCESS,
    ON_VERIFY_ACCOUNT_RECOVERY_NEXT_STEP,
    ON_VERIFY_AUTH_ACCOUNT_RECOVERY,
    ON_VERIFY_AUTH_ACCOUNT_RECOVERY_ERROR,
    ON_VERIFY_AUTH_ACCOUNT_RECOVERY_SUCCESS,
    QR_CODE_CANNOT_SCAN,
    QR_CODE_CANNOT_SCAN_NEXT,
    QR_CODE_NEXT,
    SET_AUTHENTICATOR,
    SET_DEVICE_TYPE,
    SET_OPTIONAL_AUTHENTICATOR,
    SKIP_ENROLLMENT,
    SKIP_ENROLLMENT_ERROR,
    SKIP_ENROLLMENT_SUCCESS,
    VALIDATE_SESSION,
    VALIDATE_SESSION_ERROR,
    VALIDATE_SESSION_SUCCESS,
    VERIFY_AUTHENTICATOR_CODE,
    VERIFY_AUTHENTICATOR_CODE_SUCCESS,
    VERIFY_AUTHENTICATOR_CODE_ERROR,
    VERIFY_AUTHENTICATOR_CODE_NEXT_STEP,
    RESET_AUTH_VERIFIED,
    VERIFY_PUSH,
    VERIFY_PUSH_ERROR,
    VERIFY_PUSH_SUCCESS,
    GET_BANNER_INFO,
    GET_BANNER_INFO_SUCCESS,
    GET_BANNER_INFO_FAIL,
    CLOSE_BANNER,
    SESSION_TIMEOUT,
    GET_ACCOUNT_RECOVERY,
    GET_ACCOUNT_RECOVERY_SUCCESS,
    GET_ACCOUNT_RECOVERY_ERROR,
    ENROLL_MFA_INIT,
    ENROLL_MFA_INIT_SUCCESS,
    ENROLL_MFA_INIT_FAILURE,
    VALIDATE_PHONE_AT_LOGIN,
    VALIDATE_PHONE_AT_LOGIN_ERROR,
    VALIDATE_PHONE_AT_LOGIN_SUCCESS,
    ON_SEND_CHALLENGE,
    ON_SEND_CHALLENGE_ERROR,
    ON_SEND_CHALLENGE_SUCCESS,
    MAGIC_LINK_LOGIN,
    MAGIC_LINK_LOGIN_SUCCESS,
    MAGIC_LINK_LOGIN_ERROR,
    MAGIC_LINK_VERIFY,
    MAGIC_LINK_VERIFY_SUCCESS,
    MAGIC_LINK_VERIFY_ERROR,
} from '../constants/login'
import { clearCookies, setRedirectedCookie, hasRedirectedCookie, deleteRedirectedCookie } from '../utils/cookie'
import { isSessionTimedOutWithMsg as isSessionTimedOut } from '../utils/app-context'
import { hideLoader } from '../utils/loader-actions'


const onInit = () => ({ type: ON_INIT })
export const onInitSuccess = payload => ({ payload, type: ON_INIT_SUCCESS })
export const onInitFailure = payload => ({ payload, type: ON_INIT_ERROR })

export const getBannerInfo = payload => ({ payload, type: GET_BANNER_INFO })
export const getBannerInfoSuccess = payload => ({ payload, type: GET_BANNER_INFO_SUCCESS })
export const getBannerInfoFail = payload => ({ payload, type: GET_BANNER_INFO_FAIL })
export const closeBanner = payload => ({ payload, type: CLOSE_BANNER })

export const validateSession = () => ({ type: VALIDATE_SESSION })
export const validateSessionSuccess = payload => ({ payload, type: VALIDATE_SESSION_SUCCESS })
export const validateSessionFailure = payload => ({ payload, type: VALIDATE_SESSION_ERROR })

export const onRequestLoginMagicLink = () => ({ type: MAGIC_LINK_LOGIN })
export const onRequestLoginMagicLinkFailure = payload => ({ payload, type: MAGIC_LINK_LOGIN_ERROR })
export const onRequestLoginMagicLinkSuccess = payload => ({ payload, type: MAGIC_LINK_LOGIN_SUCCESS })

export const onRequestVerifyMagicLink = () => ({ type: MAGIC_LINK_VERIFY })
export const onRequestVerifyMagicLinkFailure = payload => ({ payload, type: MAGIC_LINK_VERIFY_ERROR })
export const onRequestVerifyMagicLinkSuccess = payload => ({ payload, type: MAGIC_LINK_VERIFY_SUCCESS })

const forgotpwd = () => ({ type: FORGOTPWD })
const forgotpwdFailure = payload => ({ payload, type: FORGOTPWD_ERROR })
const forgotpwdSuccess = payload => ({ payload, type: FORGOTPWD_SUCCESS })

export const onAuthenticate = () => ({ type: ON_AUTHENTICATE })
export const onAuthenticateFailure = payload => ({ payload, type: ON_AUTHENTICATE_ERROR })
export const onAuthenticateSuccess = payload => ({ payload, type: ON_AUTHENTICATE_SUCCESS })

export const onVerifyAuthAccountRecovery = () => ({ type: ON_VERIFY_AUTH_ACCOUNT_RECOVERY })
export const onVerifyAuthAccountRecoveryFailure = payload => ({ payload, type: ON_VERIFY_AUTH_ACCOUNT_RECOVERY_ERROR })
export const onVerifyAuthAccountRecoverySuccess = payload => ({ payload, type: ON_VERIFY_AUTH_ACCOUNT_RECOVERY_SUCCESS })

export const onVerifyPush = () => ({ type: VERIFY_PUSH })
export const onVerifyPushFailure = payload => ({ payload, type: VERIFY_PUSH_ERROR })
export const onVerifyPushSuccess = payload => ({ payload, type: VERIFY_PUSH_SUCCESS })

export const onVerifyAccountRecovery = () => ({ type: ON_VERIFY_ACCOUNT_RECOVERY })
export const onVerifyAccountRecoveryFailure = payload => ({ payload, type: ON_VERIFY_ACCOUNT_RECOVERY_ERROR })
export const onVerifyAccountRecoverySuccess = payload => ({ payload, type: ON_VERIFY_ACCOUNT_RECOVERY_SUCCESS })
export const onVerifyAccountRecoveryNextStep = payload => ({ payload, type: ON_VERIFY_ACCOUNT_RECOVERY_NEXT_STEP })

export const onSetAuthenticator = payload => ({ payload, type: SET_AUTHENTICATOR })
export const onSetOptionalAuthenticator = payload => ({ payload, type: SET_OPTIONAL_AUTHENTICATOR })

export const onBackToAuthenticators = () => ({ type: ON_BACK_AUTHENTICATORS })
export const onBackToOptionalAuthenticators = () => ({ type: ON_BACK_OPTIONAL_AUTHENTICATORS })
export const backFallbackEnforceMFA = () => ({ type: ON_BACK_FALLBACK_ENFORCE_MFA })
export const backFallbackEnforceMFATwoSteps = () => ({ type: ON_BACK_FALLBACK_ENFORCE_MFA_TWO_STEPS })
export const onSetDeviceType = () => ({ type: SET_DEVICE_TYPE })

export const initEnrollAuthFactor = payload => ({ payload, type: INIT_ENROLL_AUTH_FACTOR })
export const initEnrollAuthFactorSuccess = payload => ({ payload, type: INIT_ENROLL_AUTH_FACTOR_SUCCESS })
export const initEnrollAuthFactorFailure = payload => ({ payload, type: INIT_ENROLL_AUTH_FACTOR_ERROR })

export const onQRCodeNext = () => ({ type: QR_CODE_NEXT })

export const onQRCodeCannotScan = () => ({ type: QR_CODE_CANNOT_SCAN })

export const onQRCodeCannotScanNext = () => ({ type: QR_CODE_CANNOT_SCAN_NEXT })

export const onActivateAuthenticatorCode = payload => ({ payload, type: ACTIVATE_AUTHENTICATOR_CODE })
export const onActivateAuthenticatorCodeSuccess = payload => ({ payload, type: ACTIVATE_AUTHENTICATOR_CODE_SUCCESS })
export const onActivateAuthenticatorCodeFailure = payload => ({ payload, type: ACTIVATE_AUTHENTICATOR_CODE_ERROR })
export const onActivateAuthenticatorCodeNextStep = payload => ({ payload, type: ACTIVATE_AUTHENTICATOR_CODE_NEXT_STEP })

export const onVerifyAuthenticatorCode = payload => ({ payload, type: VERIFY_AUTHENTICATOR_CODE })
export const onVerifyAuthenticatorCodeSuccess = payload => ({ payload, type: VERIFY_AUTHENTICATOR_CODE_SUCCESS })
export const onVerifyAuthenticatorCodeFailure = payload => ({ payload, type: VERIFY_AUTHENTICATOR_CODE_ERROR })
export const onVerifyAuthenticatorCodeNextStep = payload => ({ payload, type: VERIFY_AUTHENTICATOR_CODE_NEXT_STEP })

export const resetAuthVerified = () => ({ type: RESET_AUTH_VERIFIED })

export const onSkipEnrollment = payload => ({ payload, type: SKIP_ENROLLMENT })
export const onSkipEnrollmentSuccess = payload => ({ payload, type: SKIP_ENROLLMENT_SUCCESS })
export const onSkipEnrollmentFailure = payload => ({ payload, type: SKIP_ENROLLMENT_ERROR })

export const onEnrollMFA = () => ({ type: ON_ENROLL_MFA })
export const onEnrollMFAFailure = payload => ({ payload, type: ON_ENROLL_MFA_ERROR })
export const onEnrollMFASuccess = payload => ({ payload, type: ON_ENROLL_MFA_SUCCESS })

export const onSendChallenge = () => ({ type: ON_SEND_CHALLENGE })
export const onSendChallengeFailure = payload => ({ payload, type: ON_SEND_CHALLENGE_ERROR })
export const onSendChallengeSuccess = payload => ({ payload, type: ON_SEND_CHALLENGE_SUCCESS })

export const onResendAuthChallenge = () => ({ type: ON_RESEND_AUTH_CHALLENGE })
export const onResendAuthChallengeFailure = payload => ({ payload, type: ON_RESEND_AUTH_CHALLENGE_ERROR })
export const onResendAuthChallengeSuccess = payload => ({ payload, type: ON_RESEND_AUTH_CHALLENGE_SUCCESS })

export const onResendChallenge = () => ({ type: ON_RESEND_CHALLENGE })
export const onResendChallengeFailure = payload => ({ payload, type: ON_RESEND_CHALLENGE_ERROR })
export const onResendChallengeSuccess = payload => ({ payload, type: ON_RESEND_CHALLENGE_SUCCESS })

export const initAuthenticators = () => ({ type: INIT_AUTHENTICATORS })
export const initAuthenticatorsSuccess = payload => ({ payload, type: INIT_AUTHENTICATORS_SUCCESS })
export const initAuthenticatorsFailure = payload => ({ payload, type: INIT_AUTHENTICATORS_ERROR })

export const onLoginApp = () => ({ type: ON_LOGIN_APP })
export const onLoginAppSuccess = payload => ({ payload, type: ON_LOGIN_APP_SUCCESS })
export const onLoginAppFailure = payload => ({ payload, type: ON_LOGIN_APP_ERROR })

export const sessionTimeout = () => ({ type: SESSION_TIMEOUT })

export const getAccountRecoveryInit = () => ({ type: GET_ACCOUNT_RECOVERY })
export const getAccountRecoverySuccess = payload => ({ payload, type: GET_ACCOUNT_RECOVERY_SUCCESS })
export const getAccountRecoveryError = payload => ({ payload, type: GET_ACCOUNT_RECOVERY_ERROR })

export const enrollMFAInit = () => ({ type: ENROLL_MFA_INIT })
export const enrollMFAInitSuccess = () => ({ type: ENROLL_MFA_INIT_SUCCESS })
export const enrollMFAInitFailure = () => ({ type: ENROLL_MFA_INIT_FAILURE })

export const OnValidatePhoneAtLogin = () => ({ type: VALIDATE_PHONE_AT_LOGIN })
export const OnValidatePhoneAtLoginFailure = payload => ({ payload, type: VALIDATE_PHONE_AT_LOGIN_ERROR })
export const OnValidatePhoneAtLoginSuccess = payload => ({ payload, type: VALIDATE_PHONE_AT_LOGIN_SUCCESS })

const handleOktaSession = async (loginPageLoad, oktaCurrentSession, logoutOAGSessionUrl, cmxClean, secure2Clean, protectedClean, digitalMarketplaceUrl) => {
    try {
        if (oktaCurrentSession) {
            await axios.head(oktaCurrentSession, { timeout: 2000 })
            const result = await axios.get(oktaCurrentSession, { timeout: 2000 })
            console.log('Active Okta Session Retrieved: ', result)
            const redirectedOnceToDM = hasRedirectedCookie()
            if (
                loginPageLoad
                && result.data.expiresAt
                && new Date(result.data.expiresAt) > new Date()
                && !redirectedOnceToDM
            ) {
                setRedirectedCookie()
                window.__autoRedirecting = true
                const mainDomain = window.location.hostname.substring(window.location.hostname.indexOf('.'))
                document.cookie = `${cookieNameAppAutoRedirect}=true;domain=${mainDomain};path=/;SameSite=Strict`
                window.location.href = digitalMarketplaceUrl
                return { redirected: true }
            } else {
                await logoutOAGSession(oktaCurrentSession, logoutOAGSessionUrl, cmxClean, secure2Clean, protectedClean)
                return { redirected: false }
            }
        }
    } catch (err) {
        console.error('Active Okta Session Retrieval or killing failed: ', err)
        await logoutOAGSession(oktaCurrentSession, logoutOAGSessionUrl, cmxClean, secure2Clean, protectedClean, true)
        return { redirected: false }
    }
}

const logoutOAGSession = async (oktaCurrentSession, logoutOAGSessionUrl, cmxClean, secure2Clean, protectedClean, clearOktaSession = false) => {
    try {
        deleteRedirectedCookie()

        const promises = []
        if (!clearOktaSession && oktaCurrentSession) {
            promises.push(axios.delete(oktaCurrentSession, { timeout: 2000 }))
        }
        promises.push(fetch(logoutOAGSessionUrl, {
            credentials: 'include',
            method: 'GET',
            mode: 'no-cors'
        }))

        const [ deleteResult ] = await Promise.allSettled(promises)

        if (!clearOktaSession && deleteResult.status === 'rejected') {
            console.warn('Okta session delete failed:', deleteResult.reason)
        }

    } catch (err) {
        console.error('Failed to Kill OAG & GA Session, err: ', err)
    }
    setTimeout(() => {
        clearCookies(cmxClean, 'OAG cookies')
        clearCookies(secure2Clean, 'OAG secure2 cookies')
        clearCookies(protectedClean, 'OAG protected cookies')
    }, 0)
}

export const init = (loginPageLoad, oktaCurrentSession, logoutOAGSessionUrl, cmxClean, secure2Clean, protectedClean, digitalMarketplaceUrl) => {
    return async dispatch => {
        dispatch(onInit())

        if (!window.location.origin.includes('localhost')) {
            const [ oktaResult ] = await Promise.allSettled([
                handleOktaSession(loginPageLoad, oktaCurrentSession, logoutOAGSessionUrl, cmxClean, secure2Clean, protectedClean, digitalMarketplaceUrl)
            ])
            if (oktaResult.status === 'fulfilled' && oktaResult.value?.redirected) {
                return
            }
            dispatch(onInitSuccess())
        } else {
            dispatch(onInitSuccess())
        }
    }
}

export const maintenanceBanner = () => {
    return dispatch => {
        dispatch(getBannerInfo())

        axios.get(bannerInfo)
            .then(result => dispatch(getBannerInfoSuccess(result.data.data)))
            .catch(err => dispatch(getBannerInfoFail(err.response.data.error)))
    }
}

export const forgotPassword = login => {
    return dispatch => {
        dispatch(forgotpwd())

        axios.post(routes.forgotPassword, { login })
            .then(result => dispatch(forgotpwdSuccess(result.data.data)))
            .catch(err => dispatch(forgotpwdFailure(err.response.data.error)))
    }
}

export const requestLoginMagicLink = body => {
    return dispatch => {
        dispatch(onRequestLoginMagicLink())

        axios.post(routes.passwordLessLogin, body)
            .then(result => dispatch(onRequestLoginMagicLinkSuccess(result.data.data)))
            .catch(err => dispatch(onRequestLoginMagicLinkFailure(err.response.data.error)))
    }
}

export const verifyLoginMagicLink = body => {
    return dispatch => {
        dispatch(onRequestVerifyMagicLink())

        axios.post(routes.passwordLessVerification, body)
            .then(result => dispatch(onRequestVerifyMagicLinkSuccess(result.data.data)))
            .catch(err => dispatch(onRequestVerifyMagicLinkFailure(err.response.data.error)))
    }
}

export const authenticate = body => {
    return dispatch => {
        dispatch(onAuthenticate())

        axios.post(routes.authenticate, body)
            .then(result => {
                const data = result.data.data
                
                // HedgeX/AAG user: redirect to activation URL if provided
                if (data.hedgexMigration === true && data.activationURL) {
                    // Store migration flag in sessionStorage for the registration flow
                    sessionStorage.setItem('hedgexMigration', 'true')
                    if (data.aagMigration === true) {
                        sessionStorage.setItem('aagMigration', 'true')
                    }
                    // Validate and sanitize the activation URL to prevent open redirect
                    const sanitizedUrl = sanitizeRedirectUrl(data.activationURL, '/login')
                    window.location.href = sanitizedUrl
                    return
                }
                
                dispatch(onAuthenticateSuccess(data))
            })
            .catch(err => dispatch(onAuthenticateFailure(err.response.data.error)))
    }
}

export const setAuthenticator = () => dispatch => dispatch(onSetAuthenticator())
export const setOptionalAuthenticator = () => dispatch => dispatch(onSetOptionalAuthenticator())

export const backToAuthenticators = () => dispatch => dispatch(onBackToAuthenticators())
export const backToOptionalAuthenticators = () => dispatch => dispatch(onBackToOptionalAuthenticators())

export const setDeviceType = () => dispatch => dispatch(onSetDeviceType())

export const enrollAuthFactor = body => {
    return dispatch => {
        dispatch(initEnrollAuthFactor())

        axios.post(routes.enrollAuthFactor, body)
            .then(result => dispatch(initEnrollAuthFactorSuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(initEnrollAuthFactorFailure(err.response.data.error))
            })
    }
}

export const qrCodeNext = () => dispatch => dispatch(onQRCodeNext())

export const qrCodeCannotScan = () => dispatch => dispatch(onQRCodeCannotScan())

export const qrCodeCannotScanNext = () => dispatch => dispatch(onQRCodeCannotScanNext())

export const activateAuthenticatorCode = body => {
    return dispatch => {
        dispatch(onActivateAuthenticatorCode())

        axios.post(routes.activateFactor, body)
            .then(result => {
                dispatch(onActivateAuthenticatorCodeSuccess(result.data.data))
                setTimeout(() => {
                    dispatch(onActivateAuthenticatorCodeNextStep(result.data.data))
                }, 3000)
            })
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(onActivateAuthenticatorCodeFailure(err.response.data.error))
            })
    }
}

export const verifyAuthenticatorCode = body => {
    return dispatch => {
        dispatch(onVerifyAuthenticatorCode())

        axios.post(routes.verifyFactor, body)
            .then(result => {
                dispatch(onVerifyAuthenticatorCodeSuccess(result.data.data))
                setTimeout(() => {
                    dispatch(onVerifyAuthenticatorCodeNextStep(result.data.data))
                }, 3000)
            })
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(onVerifyAuthenticatorCodeFailure(err.response.data.error))
            })
    }
}

let pushVerificationAbortController = null

export const verifyPush = body => {
    return dispatch => {
        if (pushVerificationAbortController) {
            pushVerificationAbortController.abort()
        }

        pushVerificationAbortController = new AbortController()

        dispatch(onVerifyPush())

        axios.post(routes.verifyFactor, body, {
            signal: pushVerificationAbortController.signal
        })
            .then(result => {
                pushVerificationAbortController = null
                dispatch(onVerifyPushSuccess(result.data.data))
            })
            .catch(err => {
                if (!isCancel(err)) {
                    pushVerificationAbortController = null
                    if (isSessionTimedOut(err)) {
                        return dispatch(sessionTimeout())
                    }
                    dispatch(onVerifyPushFailure(err.response.data.error))
                }
            })
    }
}

export const skipMfaEnrollment = body => {
    return dispatch => {
        dispatch(onSkipEnrollment())

        axios.post(routes.skipEnrollment, body)
            .then(result => {
                console.log('skipEnrollment response:', result.data.data)
                dispatch(onSkipEnrollmentSuccess(result.data.data))
            })
            .catch(err => {
                const errorMsg = err.response?.data?.error || err.message
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(onSkipEnrollmentFailure(errorMsg))
            })
    }
}

export const verifyAccountRecovery = body => {
    return dispatch => {
        dispatch(onVerifyAccountRecovery())

        axios.post(routes.verifyAccountRecovery, body)
            .then(result => {
                if (result.data.error) {
                    dispatch(onVerifyAccountRecoveryFailure(result.data.error))
                } else if (result.data.data) {
                    dispatch(onVerifyAccountRecoverySuccess(result.data.data))
                    setTimeout(() => {
                        dispatch(onVerifyAccountRecoveryNextStep(result.data.data))
                    }, 3000)
                }
            })
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(onVerifyAccountRecoveryFailure(err.response.data.error))
            })
    }
}

export const enrollMFA = body => {
    return dispatch => {
        dispatch(onEnrollMFA())

        axios.post(routes.enrollMFA, body)
            .then(result => dispatch(onEnrollMFASuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(onEnrollMFAFailure(err.response.data.error))
            })
    }
}

export const sendChallenge = body => {
    return dispatch => {
        dispatch(onSendChallenge())

        axios.post(routes.enrollMFA, body)
            .then(result => dispatch(onSendChallengeSuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(onSendChallengeFailure(err.response.data.error))
            })
    }
}

export const resendChallenge = body => {
    return dispatch => {
        dispatch(onResendChallenge())

        axios.post(routes.sendChallenge, body)
            .then(result => dispatch(onResendAuthChallengeSuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                const errorMsg = err.response?.data?.error || err.message || 'Failed to send challenge'
                console.error('resendChallenge error:', errorMsg, err)
                dispatch(onResendAuthChallengeFailure(errorMsg))
            })
    }
}

export const getAuthenticators = () => {
    return dispatch => {
        dispatch(initAuthenticators())

        axios.get(routes.getAuthenticators)
            .then(result => {
                const combinedData = result.data.data
                dispatch(initAuthenticatorsSuccess(combinedData))
            })
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(initAuthenticatorsFailure(err.response?.data?.error))
            })
    }
}

export const loginApp = body => {
    return dispatch => {
        dispatch(onLoginApp())

        axios.post(routes.loginApp, body)
            .then(result => dispatch(onLoginAppSuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(onLoginAppFailure(err.response.data.error))
            })
    }
}


export const getAccountRecovery = body => {
    return dispatch => {
        dispatch(getAccountRecoveryInit())

        axios.post(routes.getAccountRecovery, body)
            .then(result => dispatch(getAccountRecoverySuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(getAccountRecoveryError(err.response.data.error))
            })
    }
}

export const validatePhoneAtLogin = body => {
    return dispatch => {
        dispatch(OnValidatePhoneAtLogin())

        axios.post(routes.sendChallenge, body)
            .then(result => dispatch(OnValidatePhoneAtLoginSuccess(result.data.data)))
            .catch(err => {
                const errorMsg = err.response?.data?.error || err.message || 'Failed to validate phone'
                console.error('validatePhoneAtLogin error:', errorMsg, err)
                dispatch(OnValidatePhoneAtLoginFailure(errorMsg))
            })
    }
}

export const preActivateAlternateAccountRecovery = body => {
    return dispatch => {
        dispatch(enrollMFAInit())

        axios.post(routes.preActivateAlternateAccountRecovery, body)
            .then(result => dispatch(enrollMFAInitSuccess(result.data.data)))
            .catch(err => {
                hideLoader()
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                const errorMsg = err?.response?.data?.error || err.message
                dispatch(enrollMFAInitFailure(errorMsg))
            })
    }
}

